import script from "./CreateUpdateSiglas.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUpdateSiglas.vue?vue&type=script&setup=true&lang=js"

import "./CreateUpdateSiglas.vue?vue&type=style&index=0&id=5ba579ba&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ba579ba"]])

export default __exports__